const topicItems = [
  { name: '奇幻冒险', count: '4.8万', hot: true },
  { name: '星之妖精', count: '3.2万', hot: true },
  { name: '魔导师传说', count: '2.9万', hot: true },
  { name: '萌系日常', count: '2.6万', hot: false },
  { name: '异世界', count: '2.3万', hot: true },
  { name: '小妖精', count: '2.1万', hot: false },
  { name: '精灵之森', count: '1.9万', hot: false },
  { name: '漫画追更', count: '1.7万', hot: false },
  { name: '新番推荐', count: '1.5万', hot: true },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-5xl mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-3">
          热门话题
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10 md:mb-14 max-w-lg mx-auto">
          读者正在热烈讨论的漫画话题与作品标签
        </p>

        <div className="flex flex-wrap justify-center gap-3">
          {topicItems.map((item, i) => (
            <a
              key={i}
              href="#topics"
              className="group flex items-center gap-2 px-4 py-2.5 rounded-full border border-background-300 bg-background-50 hover:border-primary-300 hover:bg-primary-50 transition-all cursor-pointer"
            >
              {item.hot && (
                <span className="w-4 h-4 flex items-center justify-center flex-shrink-0">
                  <i className="ri-fire-line text-accent-500 text-xs"></i>
                </span>
              )}
              <span className="text-sm font-medium text-foreground-800 group-hover:text-primary-600 transition-colors whitespace-nowrap">
                {item.name}
              </span>
              <span className="text-xs text-foreground-400">{item.count}讨论</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}